import React from "react";
import styled from "styled-components";
import UserListItemLoader from "../People/UserListItemLoader";

interface IContactsListItemLoaderPlaceholder {
  loading?: boolean;
  count?: number;
}

const ContactsListItemLoaderPlaceholder: React.FC<IContactsListItemLoaderPlaceholder> = (props) => {
  const { loading, count } = props;

  return (
    <>
      {loading ? (
        <Wrapper>
          {[...Array.from(Array(count).keys(), (n) => n + 1)].map((item, index): any => {
            return (
              <div key={index} className={``}>
                <UserListItemLoader inListContacts={true} />
              </div>
            );
          })}
        </Wrapper>
      ) : null}
    </>
  );
};

export default ContactsListItemLoaderPlaceholder;

const Wrapper = styled.div``;
